<script>
  // # # # # # # # # # # # # #
  //
  //  About (fka. vision) page
  //
  // # # # # # # # # # # # # #

  // *** IMPORT
  import { fade } from "svelte/transition";
  import { onMount } from "svelte";

  // *** PROPS
  export let endpoint = "";
  export let title = "";

  const post = loadData();

  // *** ON MOUNT
  async function loadData() {
    const res = await fetch(endpoint);
    const post = await res.json();
    return post;
  }

  // *** ON MOUNT
  onMount(async () => {
    window.scrollTo(0, 0);
  });
</script>

<style lang="scss">
  @import "../_variables.scss";

  .vision {
    color: $black;
    display: inline-block;
    margin-top: $top-space;
    margin-bottom: $bottom-space;
    width: 100%;
    font-family: $serif-stack;
    font-size: $font-size-large;

    @include screen-size("small") {
      font-size: $mobile-font-size-medium;
      width: calc(100vw - 40px);
      margin-right: $main-margin;
      margin-left: $main-margin;
    }

    p {
      margin-top: 0;
      margin-bottom: 1em;
    }

    &__main {
      margin-left: auto;
      margin-right: auto;
      width: 70%;

      @include screen-size("small") {
        display: inline-block;
        width: 100%;
      }
    }

    &__column {
      line-height: 1.3em;
      width: 100%;
      max-width: 70ch;
      text-align: center;
      margin-right: auto;
      margin-left: auto;

      p {
        margin-bottom: 5em;
      }

      // float: left;

      // &--left {
      //   text-align: right;
      //   padding-right: 10px;
      //   max-width: 50ch;
      // }

      // &--right {
      //   text-align: left;
      //   padding-left: 10px;
      //   max-width: 50ch;
      // }

      // @include screen-size("small") {
      //   // width: 100%;
      //   // margin-right: auto;
      //   // margin-left: auto;
      //   // float: unset;

      //   &--left {
      //     // text-align: center;
      //     padding-right: 0px;
      //   }

      //   &--right {
      //     text-align: center;
      //     padding-left: 0px;
      //     margin-top: 0;
      //     margin-right: auto;
      //     margin-right: auto;
      //   }
      // }
    }
  }
</style>

<svelte:head>
  <title>{title} | COMPLETE WORKS</title>
</svelte:head>

{#await post then post}

  <div class="vision" in:fade>

    <div class="vision__main">

      <div class="vision__column vision__column--left">
        {@html post.header.column_one}
      </div>

      <div class="vision__column vision__column--right">
        {@html post.header.column_two}
      </div>

    </div>

  </div>

{/await}
